import axiosInstance from "../../Lib/axios";
import {
  GET_LIST_SUCCESSFULLY,
  GET_LIST_FAILED,
  ADD_QUOTE,
  ADD_QUOTE_FAILED,
  UPDATE_QUOTE,
  UPDATE_QUOTE_FAILED,
  GET_COMMERCIAL_CUSTOMER_LIST,
  GET_COMMERCIAL_CUSTOMER_LIST_FAILED,
  GET_COMMERCIAL_CUSTOMER,
  GET_COMMERCIAL_CUSTOMER_FAILED,
  UPDATE_COMMERCIAL_CUSTOMER,
  UPDATE_COMMERCIAL_CUSTOMER_FAILED,
  DELETE_COMMERCIAL_CUSTOMER,
  DELETE_COMMERCIAL_CUSTOMER_FAILED,
  ADD_GUEST_USER,
  ADD_GUEST_USER_FAILED,
  UPDATE_GUEST_USER,
  UPDATE_GUEST_USER_FAILED,
  DELETE_GUEST_USER,
  DELETE_GUEST_USER_FAILED,
  GET_RESOURCE_LIST,
  GET_RESOURCE_LIST_FAILED,
  ADD_RESOURCE,
  ADD_RESOURCE_FAILED,
  UPDATE_RESOURCE,
  UPDATE_RESOURCE_FAILED,
  DELETE_RESOURCE,
  DELETE_RESOURCE_FAILED,
  GET_QUOTE_DETAIL,
  GET_QUOTE_DETAIL_FAILED,
  ADD_COMMERCIAL_PROPOSAL,
  ADD_COMMERCIAL_PROPOSAL_FAILED,
  ADD_INNER_COMMERCIAL_PROPOSAL,
  ADD_INNER_COMMERCIAL_PROPOSAL_FAILED,
  UPDATE_INNER_COMMERCIAL_PROPOSAL,
  UPDATE_INNER_COMMERCIAL_PROPOSAL_FAILED,
  GET_COMMERCIAL_PROPOSAL_FAILED,
  GET_COMMERCIAL_PROPOSAL,
  PATCH_COMMERCIAL_PROPOSAL,
  PATCH_COMMERCIAL_PROPOSAL_FAILED,
  DELETE_COMMERCIAL_PROPOSAL_LINE_ITEM,
  DELETE_COMMERCIAL_PROPOSAL_LINE_ITEM_FAILED,
  GET_COMMERCIAL_PROPOSAL_DETAIL,
  GET_COMMERCIAL_PROPOSAL_DETAIL_FAILED,
  GET_KANBAN_LIST,
  GET_KANBAN_LIST_FAILED,
  REQUEST_REPAIR,
  REQUEST_REPAIR_FAILED,
  SERVICE_AGREEMENT_LIST,
  SERVICE_AGREEMENT_LIST_FAILED,
  ADD_SERVICE_AGREEMENT,
  ADD_SERVICE_AGREEMENT_FAILED,
  DELETE_SERVICE_AGREEMENT,
  DELETE_SERVICE_AGREEMENT_FAILED,
  SEND_COMMERCIAL_PROPOSAL_MAIL,
  SEND_COMMERCIAL_PROPOSAL_MAIL_FAILED,
  ADD_PWS_INSTALL,
  ADD_PWS_INSTALL_FAILED,
  UPDATE_PWS_INSTALL,
  UPDATE_PWS_INSTALL_FAILED,
  GET_PROPOSAL_PDF,
  GET_PROPOSAL_PDF_FAILED,
  CHECK_EMAIL,
  CHECK_EMAIL_FAILED,
  UPDATE_SERVICE_LINE_ITEM,
  UPDATE_SERVICE_LINE_ITEM_FAILED,
  CHECK_MAIL_SUCCESSFULLY,
  CHECK_MAIL_FAILED,
  GET_EXPORT_INVOICE_SAATEMENT_SUCCESSFULLY,
  GET_EXPORT_INVOICE_SAATEMENT_FAILED,
  GET_BDA_FAILED, GET_BDA, DELETE_INNER_PROPOSAL, DELETE_INNER_PROPOSAL_FAILED,
  GET_COM_WORK_ORDER_LIST,GET_COM_WORK_ORDER_LIST_FAILED,
  GET_COM_WORK_ORDER,GET_COM_WORK_ORDER_FAILED,
  VOID_INVOICE_SUCCESSFULLY,VOID_INVOICE_FAILED,
  GET_PAYMENT_HISTORY_SUCCESSFULLY,
  DELETE_PAYMENT_HISTORY_SUCCESSFULLY,
  DELETE_PAYMENT_HISTORY_FAILED,
  POST_PAYMENT_HISTORY_SUCCESSFULLY,
  GET_PAYMENT_HISTORY_NEW_FAILED,
  GET_PAYMENT_HISTORY_NEW_SUCCESSFULLY,
  GET_PAYMENT_HISTORY_FAILED,
  POST_PAYMENT_HISTORY_FAILED,
  ADD_MANUAL_INVOICE,
  ADD_MANUAL_INVOICE_FAILED,
  GET_BILLING_ADDRESS_SUCCESSFULLY,
  GET_BILLING_ADDRESS_FAILED,
  GET_STAFF_LIST_SUCCESSFULLY,
  GET_STAFF_LIST_FAILED,
  GET_SERVICE_ORDERS_SUCCESSFULLY,
  GET_SERVICE_ORDERS_FAILED,
  GET_DISCOUNTS_CATALOG_SUCCESSFULY,
  GET_DISCOUNTS_CATALOG_FAILED,
  CALCULATE_PREPAY_PRICE_SUCCESSFULY,
  CALCULATE_PREPAY_PRICE_FAILED,
  PREPAY_CREATED_SUCCESSFULY,
  PREPAY_CREATED_FAILED,
  REFUND_REMAINING_BALANCE_SUCCESS,
  REFUND_REMAINING_BALANCE_FAILED,
  CLEAN_PREPAYMENT_RESPONSE
} from "../types";

import {PaymentWrapper} from '../Accounting/PaymentWrapper';

//check email
export const checkEmail = (email) => {
  return (dispatch) => {
    return axiosInstance
      .get(`accounts/check-email?email=${email}`)
      .then((response) => {
        dispatch({
          type: CHECK_EMAIL,
          data: response?.data?.already_exists,
        });
      })
      .catch((error) => {
        if (error?.response?.status === 401 || error?.response?.status === 403) {
          window.location.assign('/')
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: CHECK_EMAIL_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
}

// get proposal
export const getAllQuote = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`crm/commerical-crm/`, { params })
      .then((response) => {
        dispatch({
          type: GET_LIST_SUCCESSFULLY,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (error?.response?.status === 401 || error?.response?.status === 403) {
          window.location.assign('/')
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: GET_LIST_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
};

// add proposal
export const addQuote = (params) => {
  return (dispatch) => {
    return axiosInstance
      .post(`crm/commerical-crm/`,params)
      .then((response) => {
        dispatch({
          type: ADD_QUOTE,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (error?.response?.status === 401 || error?.response?.status === 403) {
          window.location.assign('/')
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: ADD_QUOTE_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
};

// update proposal
export const updateQuote = (uuid, params) => {
  return (dispatch) => {
    return axiosInstance
      .patch(`crm/commerical-crm/${uuid}/`, params)
      .then((response) => {
        dispatch({
          type: UPDATE_QUOTE,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (error?.response?.status === 401 || error?.response?.status === 403) {
          window.location.assign('/')
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: UPDATE_QUOTE_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
};

// get proposal by ID (Quote)
export const getQuoteById = (uuid) => {
  return (dispatch) => {
    return axiosInstance
      .get(`crm/commerical-crm/${uuid}`)
      .then((response) => {
        dispatch({
          type: GET_QUOTE_DETAIL,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (error?.response?.status === 401 || error?.response?.status === 403) {
          window.location.assign('/')
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: GET_QUOTE_DETAIL_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
};

// get commercial customers
export const getCommercialCustomerList = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`crm/commerical-customer/`, { params })
      .then((response) => {
        dispatch({
          type: GET_COMMERCIAL_CUSTOMER_LIST,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (error?.response?.status === 401 || error?.response?.status === 403) {
          window.location.assign('/')
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: GET_COMMERCIAL_CUSTOMER_LIST_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
};

// get commercial customers
export const getCommercialCustomer = (uuid) => {
  return (dispatch) => {
    return axiosInstance
      .get(`crm/commerical-customer/${uuid}`)
      .then((response) => {
        dispatch({
          type: GET_COMMERCIAL_CUSTOMER,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (error?.response?.status === 401 || error?.response?.status === 403) {
          window.location.assign('/')
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: GET_COMMERCIAL_CUSTOMER_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
};

// clear commercial customers
export const clearCommercialCustomer = () => {
  return (dispatch) => {
    dispatch({
      type: GET_COMMERCIAL_CUSTOMER,
      data: {}
    });
  };
};

// get commercial customers
export const updateCommercialCustomer = (uuid, params) => {
  return (dispatch) => {
    return axiosInstance
      .patch(`crm/commerical-customer/${uuid}/`, params)
      .then((response) => {
        dispatch({
          type: UPDATE_COMMERCIAL_CUSTOMER,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (error?.response?.status === 401 || error?.response?.status === 403) {
          window.location.assign('/')
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: UPDATE_COMMERCIAL_CUSTOMER_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
};

// get commercial customers
export const deleteCommercialCustomer = (uuid) => {
  return (dispatch) => {
    return axiosInstance
      .delete(`crm/commerical-customer/${uuid}/`)
      .then((response) => {
        dispatch({
          type: DELETE_COMMERCIAL_CUSTOMER,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (error?.response?.status === 401 || error?.response?.status === 403) {
          window.location.assign('/')
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: DELETE_COMMERCIAL_CUSTOMER_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
};

// add guest proposal
export const addGuestUser = (params) => {
  return (dispatch) => {
    return axiosInstance
      .post(`crm/guest-users/`, params)
      .then((response) => {
        dispatch({
          type: ADD_GUEST_USER,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (error?.response?.status === 401 || error?.response?.status === 403) {
          window.location.assign('/')
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: ADD_GUEST_USER_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
};

// update guest proposal
export const updateGuestUser = (params) => {
  return (dispatch) => {
    return axiosInstance
      .patch(`crm/guest-users/${params?.uuid}/`, params)
      .then((response) => {
        dispatch({
          type: UPDATE_GUEST_USER,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (error?.response?.status === 401 || error?.response?.status === 403) {
          window.location.assign('/')
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: UPDATE_GUEST_USER_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
};

// update guest proposal
export const deleteGuestUser = (uuid) => {
  return (dispatch) => {
    return axiosInstance
      .delete(`crm/guest-users/${uuid}`)
      .then((response) => {
        dispatch({
          type: DELETE_GUEST_USER,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (error?.response?.status === 401 || error?.response?.status === 403) {
          window.location.assign('/')
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: DELETE_GUEST_USER_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
};

// get commercial resource
export const getResourceList = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`crm/commercial-resources/`, {params})
      .then((response) => {
        dispatch({
          type: GET_RESOURCE_LIST,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (error?.response?.status === 401 || error?.response?.status === 403) {
          window.location.assign('/')
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: GET_RESOURCE_LIST_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
};

// add commercial resource
export const addResource = (params) => {
  return (dispatch) => {
    return axiosInstance
      .post(`crm/commercial-resources/`, params)
      .then((response) => {
        dispatch({
          type: ADD_RESOURCE,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (error?.response?.status === 401 || error?.response?.status === 403) {
          window.location.assign('/')
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: ADD_RESOURCE_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
};

// update commercial resource
export const updateResource = (params) => {
  return (dispatch) => {
    return axiosInstance
      .patch(`crm/commercial-resources/${params.uuid}/`, params)
      .then((response) => {
        dispatch({
          type: UPDATE_RESOURCE,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (error?.response?.status === 401 || error?.response?.status === 403) {
          window.location.assign('/')
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: UPDATE_RESOURCE_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
};

// delete commercial resource
export const deleteResource = (uuid) => {
  return (dispatch) => {
    return axiosInstance
      .delete(`crm/commercial-resources/${uuid}/`)
      .then((response) => {
        dispatch({
          type: DELETE_RESOURCE,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (error?.response?.status === 401 || error?.response?.status === 403) {
          window.location.assign('/')
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: DELETE_RESOURCE_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
};

// add commercial Proposal
export const addCommercialProposal = (params) => {
  return (dispatch) => {
    return axiosInstance
      .post(`/commercial-proposal/`, params)
      .then((response) => {
        dispatch({
          type: ADD_COMMERCIAL_PROPOSAL,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (error?.response?.status === 401 || error?.response?.status === 403) {
          window.location.assign('/')
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: ADD_COMMERCIAL_PROPOSAL_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
};

// add Inner commercial Proposal
export const addInnerCommercialProposal = (params) => {
  return (dispatch) => {
    return axiosInstance
      .post(`/inner-proposal/`,params)
      .then((response) => {
        dispatch({
          type: ADD_INNER_COMMERCIAL_PROPOSAL,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (error?.response?.status === 401 || error?.response?.status === 403) {
          window.location.assign('/')
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: ADD_INNER_COMMERCIAL_PROPOSAL_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
};

// update Inner commercial Proposal
export const updateInnerCommercialProposal = (uuid, params) => {
  return (dispatch) => {
    return axiosInstance
      .patch(`/inner-proposal/${uuid}/`,params)
      .then((response) => {
        dispatch({
          type: UPDATE_INNER_COMMERCIAL_PROPOSAL,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (error?.response?.status === 401 || error?.response?.status === 403) {
          window.location.assign('/')
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: UPDATE_INNER_COMMERCIAL_PROPOSAL_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
};

// get commercial proposal
export const getCommercialProposal = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get('commercial-proposal/', {params} )
      .then((response) => {
        dispatch({
          type: GET_COMMERCIAL_PROPOSAL,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (error?.response?.status === 401 || error?.response?.status === 403) {
          window.location.assign('/')
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: GET_COMMERCIAL_PROPOSAL_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
};

// get commercial proposal by id
export const getCommercialProposalById = (uuid) => {
  return (dispatch) => {
    return axiosInstance
      .get(`commercial-proposal/${uuid}/`)
      .then((response) => {
        dispatch({
          type: GET_COMMERCIAL_PROPOSAL_DETAIL,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (error?.response?.status === 401 || error?.response?.status === 403) {
          window.location.assign('/')
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: GET_COMMERCIAL_PROPOSAL_DETAIL_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
};

// update commercial proposal
export const patchCommercialProposal = (uuid, params) => {
  return (dispatch) => {
    return axiosInstance
      .patch(`/commercial-proposal/${uuid}/`, params)
      .then((response) => {
        dispatch({
          type: PATCH_COMMERCIAL_PROPOSAL,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: PATCH_COMMERCIAL_PROPOSAL_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

// delete proposal line items
export const deleteProposalLineItems = (uuid) => {
  return (dispatch) => {
    return axiosInstance
      .delete(`/proposal-line-item/${uuid}/`)
      .then((response) => {
        dispatch({
          type: DELETE_COMMERCIAL_PROPOSAL_LINE_ITEM,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: DELETE_COMMERCIAL_PROPOSAL_LINE_ITEM_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

// delete proposal line items
export const deleteInnerProposal = (uuid) => {
  return (dispatch) => {
    return axiosInstance
      .delete(`/inner-proposal/${uuid}/`)
      .then((response) => {
        dispatch({
          type: DELETE_INNER_PROPOSAL,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: DELETE_INNER_PROPOSAL_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

// Get all staff users
export const getStaffUsers = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/crm/staff-user/`, { params })
      .then((response) => {
        dispatch({
          type: GET_STAFF_LIST_SUCCESSFULLY,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (
          error?.response?.status === 401 ||
          error?.response?.status === 403
        ) {
          window.location.assign("/");
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: GET_STAFF_LIST_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
};


// Send mail
export const sendProposalMail = (uuid) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/commercial-proposal/${uuid}/send-email`)
      .then((response) => {
        dispatch({
          type: SEND_COMMERCIAL_PROPOSAL_MAIL,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: SEND_COMMERCIAL_PROPOSAL_MAIL_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

// get kanban list
export const getKanbanList = () => {
  return (dispatch) => {
    return axiosInstance
      .get(`/kanban-pws-install/`)
      .then((response) => {
        dispatch({
          type: GET_KANBAN_LIST,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (error?.response?.status === 401 || error?.response?.status === 403) {
          window.location.assign('/')
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: GET_KANBAN_LIST_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
};

// request repair service
export const requestRepairService = (params) => {
  return (dispatch) => {
    return axiosInstance
      .post(`/crm/service-request-repair/`, params)
      .then((response) => {
        dispatch({
          type: REQUEST_REPAIR,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (error?.response?.status === 401 || error?.response?.status === 403) {
          window.location.assign('/')
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: REQUEST_REPAIR_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
};

// get all service agreements
export const getServiceAgreement = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/crm/service-agreement/`, {params})
      .then((response) => {
        dispatch({
          type: SERVICE_AGREEMENT_LIST,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (error?.response?.status === 401 || error?.response?.status === 403) {
          window.location.assign('/')
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: SERVICE_AGREEMENT_LIST_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
};

// add service agreements
export const addServiceAgreement = (params) => {
  return (dispatch) => {
    return axiosInstance
      .post(`/crm/service-agreement/`, params)
      .then((response) => {
        dispatch({
          type: ADD_SERVICE_AGREEMENT,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (error?.response?.status === 401 || error?.response?.status === 403) {
          window.location.assign('/')
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: ADD_SERVICE_AGREEMENT_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
};

// delete service agreements
export const deleteServiceAgreement = (id) => {
  return (dispatch) => {
    return axiosInstance
      .delete(`/crm/service-agreement/${id}`)
      .then((response) => {
        dispatch({
          type: DELETE_SERVICE_AGREEMENT,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (error?.response?.status === 401 || error?.response?.status === 403) {
          window.location.assign('/')
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: DELETE_SERVICE_AGREEMENT_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
};

// add PWS install
export const addPWSInstall = (params) => {
  return (dispatch) => {
    return axiosInstance
      .post(`/kanban-pws-install/`, params)
      .then((response) => {
        dispatch({
          type: ADD_PWS_INSTALL,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (error?.response?.status === 401 || error?.response?.status === 403) {
          window.location.assign('/')
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: ADD_PWS_INSTALL_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
};

// update PWS install
export const updatePWSInstall = (uuid, params) => {
  return (dispatch) => {
    return axiosInstance
      .patch(`/kanban-pws-install/${uuid}/`, params)
      .then((response) => {
        dispatch({
          type: UPDATE_PWS_INSTALL,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (error?.response?.status === 401 || error?.response?.status === 403) {
          window.location.assign('/')
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: UPDATE_PWS_INSTALL_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
};

// get all service agreements
export const getProposalPdf = (uuid, params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/crm/commerical-crm/${uuid}/proposal-pdf/`, {params})
      .then((response) => {
        let byteCharacters = atob(response.data.data);
        let byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        let byteArray = new Uint8Array(byteNumbers);
        let file = new Blob([byteArray], { type: 'application/pdf;base64' });
        let fileURL = URL.createObjectURL(file);
        // window.open(fileURL);
        dispatch({
          type: GET_PROPOSAL_PDF,
          data: fileURL,
        });

      })
      .catch((error) => {
        if (error?.response?.status === 401 || error?.response?.status === 403) {
          window.location.assign('/')
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: GET_PROPOSAL_PDF_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
};

// update PWS install
export const updateServiceLineItem = (uuid, params) => {
  return (dispatch) => {
    return axiosInstance
      .patch(`/commercial-line-item/${uuid}/`, params)
      .then((response) => {
        dispatch({
          type: UPDATE_SERVICE_LINE_ITEM,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (error?.response?.status === 401 || error?.response?.status === 403) {
          window.location.assign('/')
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: UPDATE_SERVICE_LINE_ITEM_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
};

export const checkMail = (email) => {
  return (dispatch) => {
    return axiosInstance
      .get(`accounts/check-email?email=${email}`)
      .then((response) => {
        dispatch({
          type: CHECK_MAIL_SUCCESSFULLY,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (error?.response?.status === 401 || error?.response?.status === 403) {
          window.location.assign('/')
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: CHECK_MAIL_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
}

//Export Statement
export const exportPDFStatement = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/invoice/export-statements/`,{params})
      .then((response) => {
        dispatch({
          type: GET_EXPORT_INVOICE_SAATEMENT_SUCCESSFULLY,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (error?.response?.status === 401 || error?.response?.status === 403) {
          window.location.assign('/')
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: GET_EXPORT_INVOICE_SAATEMENT_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
}

// get business developer assignee
export const getBDA = (franchise_uuid) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/commercial-proposal/${franchise_uuid}/business_development_officers/`)
      .then((response) => {
        dispatch({
          type: GET_BDA,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (error?.response?.status === 401 || error?.response?.status === 403) {
          window.location.assign('/')
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: GET_BDA_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
}

// add Mannual Invoice - new
export const addManualInvoice = (params) => {
  return (dispatch) => {
    return axiosInstance
      .post(`/invoice/manual_invoice/`, params)
      .then((response) => {
        dispatch({
          type: ADD_MANUAL_INVOICE,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          dispatch({
            type: ADD_MANUAL_INVOICE_FAILED,
            data: error.response.data,
          });
        }
      });
  };
};


export const getCommercialWorkOrderList = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`commercial-workorder/`, { params })
      .then((response) => {
        
        dispatch({
          type: GET_COM_WORK_ORDER_LIST,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_COM_WORK_ORDER_LIST_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
}

export const getCommercialWorkOrder = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`commercial-workorder/`+ params )
      .then((response) => {
        
        dispatch({
          type: GET_COM_WORK_ORDER,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_COM_WORK_ORDER_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
}

//Payment History
// Get all payments
// export const getPaymentHistory = (params) => {
//   return (dispatch) => {
//     return axiosInstance
//       .get(`/crm/payment-history`, { params })
//       .then((response) => {
//         dispatch({
//           type: GET_PAYMENT_HISTORY_SUCCESSFULLY,
//           data: PaymentWrapper(response.data),
//         });
//       })
//       .catch((error) => {
//         if (error && error.response) {
//           if (error.response.status === 401 || error.response.status === 403) {
//             window.location.assign("/");
//             localStorage.clear();
//             sessionStorage.clear();
//           }
//           if (error.response) {
//             dispatch({
//               type: GET_PAYMENT_HISTORY_FAILED,
//               data: error.response.data,
//             });
//           }
//         }
//       });
//   };
// };

// export const getPaymentHistoryNew = (params) => {
//   return (dispatch) => {
//     dispatch({
//       type: GET_PAYMENT_HISTORY_NEW_SUCCESSFULLY,
//       // data : testData,          
//     });
//     return axiosInstance
//       .get(`/crm/payment-history`, { params })
//       .then((response) => {
//         dispatch({
//           type: GET_PAYMENT_HISTORY_NEW_SUCCESSFULLY,
//           data: response.data,
//           // data : testData,          
//         });
//       })
//       .catch((error) => {
//         if (error && error.response) {
//           if (error.response.status === 401 || error.response.status === 403) {
//             window.location.assign("/");
//             localStorage.clear();
//             sessionStorage.clear();
//           }
//           if (error.response) {
//             dispatch({
//               type: GET_PAYMENT_HISTORY_NEW_FAILED,
//               data: error.response.data,
//             });
//           }
//         }
//       });
//   };
// };

// Update Payment
export const postPaymentLog = (params) => {
  return (dispatch) => {
    return axiosInstance
      .patch(`/crm/manual-payment/${params.uuid}/`, params)
      .then((response) => {
        dispatch({
          type: POST_PAYMENT_HISTORY_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: POST_PAYMENT_HISTORY_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

export const cleanPaymentResponse = () => {
  return (dispatch) => {
    dispatch({ type: 'CLEAN_PAYMENT_RESPONSE' });
  }
}

// Delete Payment
// export const deletePaymentLog = (params) => {
//   return (dispatch) => {
//     return axiosInstance
//       .delete(`/crm/manual-payment/${params}`)
//       .then((response) => {
//         dispatch({
//           type: DELETE_PAYMENT_HISTORY_SUCCESSFULLY,
//           data: response.data,
//         });
//       })
//       .catch((error) => {
//         if (error && error.response) {
//           if (error.response.status === 401 || error.response.status === 403) {
//             window.location.assign("/");
//             localStorage.clear();
//             sessionStorage.clear();
//           }
//           if (error.response) {
//             dispatch({
//               type: DELETE_PAYMENT_HISTORY_FAILED,
//               data: error.response.data,
//             });
//           }
//         }
//       });
//   };
// };

export const voidInvoice = (uuid) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/invoice/${uuid}/void_invoice/`)
      .then((response) => {
        dispatch({
          type: VOID_INVOICE_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: VOID_INVOICE_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
}

/**
 * AUTHOR: Ritesh Solanki
 * @param {*} user_uuid 
 * @returns billing address array
 * <DP-4338>Reg : Commercial_Account Details : Billing addresses are shown multiple times on Add/Update</DP-4338>
 */
export const getBillingAddress = (user_uuid) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/user-billing-info/get_billing_address/?user__uuid=${user_uuid}`)
      .then((response) => {
        dispatch({
          type: GET_BILLING_ADDRESS_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_BILLING_ADDRESS_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
}

// Commercial Prepayment
// Get Service Orders for Prepay
export const getServiceOrders = (params) => {

  return (dispatch) => {
    return axiosInstance
      .get(`/commercial-service-order/get_service_orders`, {params})
      .then((response) => {
        dispatch({
          type: GET_SERVICE_ORDERS_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_SERVICE_ORDERS_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
}

// Get Discounts Catalog
export const getDiscounts = (params) => {

  return (dispatch) => {
    return axiosInstance
      .get(`/crm/discount-catalog/get_discount_values_by_type`, {params})
      .then((response) => {
        dispatch({
          type: GET_DISCOUNTS_CATALOG_SUCCESSFULY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_DISCOUNTS_CATALOG_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
}

// Calculate the price for the Prepay
export const calculatePriceForPrepay = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/commercial-service-order/calculate_price_prepay/`, {params})
      .then((response) => {
        dispatch({
          type: CALCULATE_PREPAY_PRICE_SUCCESSFULY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: CALCULATE_PREPAY_PRICE_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
}

// Create the prepay
export const createPrepay = (params) => {
  return (dispatch) => {
    return axiosInstance
      .post(`/service/create_prepayment/`, params)
      .then((response) => {
        dispatch({
          type: PREPAY_CREATED_SUCCESSFULY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: PREPAY_CREATED_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
}

// Clean Prepayment Response
export const cleanPrePaymentResponse = () => {
  return (dispatch) => {
    dispatch({ type: CLEAN_PREPAYMENT_RESPONSE });
  }
}

// Refund Payment
export const remainingCreditBalance = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/crm/refund/get-remaining-credit-balance/`, {params})
      .then((response) => {
        dispatch({
          type: REFUND_REMAINING_BALANCE_SUCCESS,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          dispatch({
            type: REFUND_REMAINING_BALANCE_FAILED,
            data: error.response.data,
          });
        }
      });
  };
};